import NextLink, { LinkProps } from 'next/link';
import classNames from 'classnames';
import { CSSProperties, FC, ReactNode } from 'react';
import { UrlObject } from 'url';

export interface ILinkProps extends LinkProps {
  children: ReactNode;
  className?: string;
  hidden?: boolean;
  href: string | UrlObject;
  rel?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  replace?: boolean;
  scroll?: boolean;
  target?: '_self' | '_blank' | '_parent' | '_top';
  style?: CSSProperties;
  title?: string;
  'aria-label'?: string;
}

const Link: FC<ILinkProps> = ({
  children,
  className,
  hidden,
  href,
  onClick,
  onMouseEnter,
  onMouseLeave,
  replace,
  rel,
  scroll,
  shallow,
  target,
  style,
  title,
  'aria-label': ariaLabel,
}) => {
  const cls = classNames('link', className);

  href = href ?? '/';
  const client = typeof href === 'object' || href?.startsWith('/');

  const commonProps = {
    className: cls,
    onClick,
    onMouseEnter,
    onMouseLeave,
    rel,
    scroll,
    shallow,
    style,
    target,
    title,
    'aria-label': ariaLabel,
    hidden,
  };

  if (client) {
    return (
      <NextLink href={href} replace={replace} {...commonProps}>
        {children}
      </NextLink>
    );
  }

  return (
    <a href={href as string} {...commonProps}>
      {children}
    </a>
  );
};

export { Link };
